module.exports = __webpack_public_path__ + "img/pay.8b5044f9.png";